import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT} from '../constants/student-course';
import {CREATE_EXAM_REPORT} from '../constants/exam-report';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT):
      return action.payload;

    case getSuccessActionType(CREATE_EXAM_REPORT):
      return state.filter(studentCourse => (studentCourse.id !== action.payload.studentCourse.id));

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT]),
  error: getErrorReducer([FETCH_REMAIN_STUDENT_COURSES_TO_CREATE_EXAM_REPORT]),
  data
});
